import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=6deb0108&scoped=true&"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmation.vue?vue&type=style&index=0&id=6deb0108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deb0108",
  null
  
)

export default component.exports